<template>
  <div>
    <v-text-field
      hide-details
      :label="title"
      prepend-inner-icon="mdi-square-edit-outline"
      @click="edit"
      v-model="text"
      filled
      readonly
    ></v-text-field>

    <v-dialog v-model="dialog" scrollable width="800">
      <v-card>
        <v-card-title>{{ title }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <v-simple-table>
            <thead>
              <tr>
                <th>Column Name</th>
                <th style="width: 40px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in columns" :key="index">
                <td>
                  <FieldPicker
                    v-model="item.column"
                    :isRequired="false"
                    :table="table"
                    :containers="containers"
                    :component="component"
                  />
                </td>
                <td>
                  <v-btn icon color="error" @click="remove(index)">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text color="primary" @click="add">
            <v-icon>mdi-plus</v-icon>
            <span>Add</span>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="save">Ok</v-btn>
          <v-btn text color="error" @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FieldPicker from "./FieldPicker.vue";

export default {
  name: "ColumnListEditor",

  components: { FieldPicker },

  props: ["title", "value", "table", "component", "containers"],

  data() {
    return {
      dialog: false,
      text: null,
      columns: [],
    };
  },

  mounted() {
    this.setText();
  },

  watch: {
    value() {
      this.setText();
    },
  },

  methods: {
    setText() {
      if (this.value) {
        this.text = "";
        this.value.forEach((i) => (this.text += i + " "));
      } else this.text = null;
    },
    edit() {
      this.columns = [];

      if (this.value) {
        this.value.forEach((v) => {
          this.columns.push({
            column: v,
          });
        });
      }

      this.dialog = true;
    },
    save() {
      this.dialog = false;
      var newValue = [];
      this.columns.forEach((i) => newValue.push(i.column));
      this.$emit("input", newValue);
    },
    add() {
      this.columns.push({
        column: null,
      });
    },
    remove(index) {
      this.columns.splice(index, 1);
    },
  },
};
</script>
